export default __webpack_public_path__ + "static/media/36I-102764_-17660_0.5976bbeb.jpg";